import classes from './CustomButton.module.css'
import { FC, ReactNode } from 'react'
import { Button, IconButton } from '@mui/material'
import classNames from 'classnames'
import { useLocale, withLocale } from '~/hooks/useLocale'
interface CustomButtonProps {
  children?: ReactNode
  icon?: ReactNode
  outlined?: boolean
  href?: string
  size?: 'small' | 'medium' | 'large'
  variant?: 'primary' | 'danger' | 'grey'
  onClick?: () => void
  disabled?: boolean
  'data-testid'?: string
}
export const CustomButton: FC<CustomButtonProps> = ({
  children,
  icon,
  outlined,
  size = 'medium',
  href,
  variant = 'primary',
  onClick,
  disabled = false,
  'data-testid': dataTestId,
}) => {
  const locale = useLocale()
  const localizedHref = href ? withLocale(href, locale) : undefined
  if (!children && icon) {
    return (
      <IconButton
        onClick={onClick}
        sx={{ fontSize: 30 }}
        data-testid={dataTestId}
        {...(localizedHref ? { component: 'a', href: localizedHref } : {})}
      >
        {icon}
      </IconButton>
    )
  }
  const additionalProps = {
    startIcon: icon,
    ...(icon && { startIcon: icon }),
    ...(localizedHref && { href: localizedHref }),
    ...(onClick && { onClick }),
  }
  return (
    <>
      <Button
        className={classNames([
          classes.ctaButton,
          outlined && classes.outlined,
          classes[`${size}Size`],
          classes[`${variant}Variant`],
        ])}
        size={size}
        disabled={disabled}
        data-testid={dataTestId}
        {...additionalProps}
      >
        <p className={classes.ctaButtonTitle}>{children}</p>
      </Button>
    </>
  )
}
